import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Skeleton,
} from "@mui/material";
import { workshopCardStyle } from "../../../../shared/styles/cardStyles";

const chipWidths = [80, 60, 50];

const WorkshopListSkeleton = ({ isDesktop }) => {
  const mobileSkeleton = (
    <>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1,
        }}
      >
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="text" width="45%" height={28} />
      </Box>

      {/* Address + Action */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="75%" />

          <Box
            sx={{
              display: "flex",
              gap: 1,
              mt: 1,
              flexWrap: "wrap",
            }}
          >
            {chipWidths.map((width) => (
              <Skeleton
                key={width}
                variant="rounded"
                width={width}
                height={20}
              />
            ))}
          </Box>
        </Box>

        <Skeleton
          variant="rounded"
          width={90}
          height={34}
          sx={{ borderRadius: 5, flexShrink: 0 }}
        />
      </Box>

      {/* Show More */}
      <Skeleton
        variant="text"
        width={100}
        height={26}
        sx={{ mt: 2 }}
      />
    </>
  );

  const desktopSkeleton = (
    <>
      <CardHeader
        avatar={
          <Skeleton variant="circular" width={40} height={40} />
        }
        title={
          <Skeleton variant="text" width="40%" height={32} />
        }
        subheader={
          <Box>
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="35%" />
          </Box>
        }
      />

      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <Skeleton
              variant="rounded"
              width={100}
              height={20}
            />

            <Skeleton
              variant="rounded"
              width={80}
              height={20}
              sx={{ mt: 1 }}
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <Skeleton variant="text" width="95%" />
            <Skeleton variant="text" width="70%" />
          </Grid>
        </Grid>
      </CardContent>

      {/* Footer */}
      <Grid
        container
        spacing={1}
        sx={{
          px: 2,
          pb: 2,
        }}
      >
        <Grid size={{ xs: 6 }}>
          <Skeleton variant="text" width={110} height={28} />
        </Grid>

        <Grid
          size={{ xs: 6 }}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Skeleton
            variant="rounded"
            width={200}
            height={40}
            sx={{ borderRadius: 5 }}
          />
        </Grid>
      </Grid>
    </>
  );

  return (
    <Grid
      className="workshop-grid-item"
      size={{ xs: 12 }}
      sx={{
        p: 0,
        mt: isDesktop ? "20px" : "8px",
      }}
    >
      <Card
        className="workshop-card"
        sx={{
          ...workshopCardStyle,
          ...(isDesktop
            ? {}
            : {
                p: "12px 16px",
              }),
        }}
      >
        {isDesktop ? desktopSkeleton : mobileSkeleton}
      </Card>
    </Grid>
  );
};

export default WorkshopListSkeleton;